import { useAction, useAtom } from '@reatom/npm-react'
import { useMemo } from 'react'
import styled from 'styled-components'

import { AsyncStateN } from '@blade/std-lib'
import { CircularLoader } from '@blade/ui-kit'
import { RectangleNetworkBackground } from '@root/shared/ui'
import { InfoMessage } from '@root/shared/ui-kit'

import { wikiSummary } from '../atoms/wiki-summary'

import { SocialWikiSummary } from './social-wiki-summary'

interface SocialWikiEmbedProps {
  articleLanguage: string
  articleTitle: string
  url: string
}

export const SocialWikiEmbed = ({
  articleLanguage,
  articleTitle,
  url,
}: SocialWikiEmbedProps) => {
  const model = useMemo(
    () =>
      wikiSummary({
        language: articleLanguage,
        title: articleTitle,
      }),
    [articleLanguage, articleTitle],
  )
  const [requestState] = useAtom(model.requestModel)
  const refresh = useAction(model.requestModel.execute)

  return (
    <Root>
      {AsyncStateN.matchWaiting(requestState, {
        Waiting: () => <Loader />,
        Error: () => <InfoMessage intent={'error'} onRetry={refresh} />,
        Success: (summary) =>
          summary.hasVisibleContent ? (
            <SocialWikiSummary url={url} summary={summary} />
          ) : (
            url
          ),
      })}
    </Root>
  )
}
const Root = styled.div`
  ${RectangleNetworkBackground}
  width: 400px;
  min-height: fit-content;
  position: relative;
  border: 1px solid var(--background-6);
  border-radius: 6px;
  overflow: hidden;
`
const Loader = () => (
  <LoaderRoot>
    <CircularLoader size={24} />
  </LoaderRoot>
)

const LoaderRoot = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 160px;
`
